/**
 * funnel-cart.js
 * Handles add-to-cart for all [data-funnel-cart-form] forms on the landing funnel.
 * Broadcasts multiple cart events to cover common Shopify theme cart drawer patterns.
 *
 * REDIRECT MODE: set window.funnelAtcMode = 'redirect' (and optionally
 * window.funnelAtcRedirectUrl) before this script runs to send all ATC
 * clicks to the product PDP instead of posting to /cart/add.js.
 */
(function () {
  'use strict';

  window.funnelState = window.funnelState || { variantId: null, price: null, compareAtPrice: null };

  // Lock to prevent duplicate submissions (causes 409 from Shopify)
  var isAdding = false;

  // ------- Add to cart -------
  async function addToCart(variantId, quantity, btn) {
    if (!variantId) {
      console.warn('[funnel-cart] No variant selected');
      return;
    }

    // Prevent duplicate/concurrent submissions — Shopify returns 409 on collision
    if (isAdding) return;
    isAdding = true;

    var originalHTML = '';
    if (btn) {
      originalHTML = btn.innerHTML;
      btn.disabled = true;
      btn.innerHTML = '<span style="letter-spacing:.06em">ADDING…</span>';
    }

    try {
      const r = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: Number(variantId), quantity: Number(quantity) || 1 })
      });

      if (!r.ok) {
        const body = await r.json().catch(() => ({}));
        throw new Error(body.description || 'cart/add.js ' + r.status);
      }

      const item = await r.json();

      // Broadcast all common Shopify theme cart events
      document.dispatchEvent(new CustomEvent('cart:refresh',           { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:updated',           { bubbles: true, detail: { item } }));
      document.dispatchEvent(new CustomEvent('cart-notification:open', { bubbles: true, detail: { item } }));

      // Theme-specific hooks used by common Shopify themes
      if (window.theme && window.theme.cart && window.theme.cart.open) {
        window.theme.cart.open();
      }
      window.dispatchEvent(new CustomEvent('cart:item-added', { bubbles: true, detail: { item } }));

      // Re-fetch cart and update count badges
      const cartRes = await fetch('/cart.js');
      if (cartRes.ok) {
        const cart = await cartRes.json();
        document.querySelectorAll('[data-cart-count], .cart-count, .cart__count').forEach(function (el) {
          el.textContent = cart.item_count;
        });
      }

    } catch (err) {
      console.error('[funnel-cart] Add to cart failed:', err.message);
      alert('Could not add to cart: ' + err.message);
    } finally {
      isAdding = false;
      if (btn) {
        btn.disabled = false;
        btn.innerHTML = originalHTML;
      }
    }
  }

  // ------- Wire up all forms -------
  function wireForm(form) {
    form.addEventListener('submit', async function (e) {
      e.preventDefault();

      // ── Redirect mode: send to PDP instead of adding to cart ──────────────
      if (window.funnelAtcMode === 'redirect') {
        var dest = window.funnelAtcRedirectUrl || '/products/bungee-rebounders-mini-trampoline';
        window.location.href = dest;
        return;
      }

      if (isAdding) return; // guard at form level too
      const variantInput = form.querySelector('[data-cart-variant]');
      const qtyInput     = form.querySelector('[name="quantity"]');
      const btn          = form.querySelector('[data-funnel-atc-btn]');
      const variantId    = (variantInput && variantInput.value) || window.funnelState.variantId;
      const qty          = (qtyInput && qtyInput.value) || 1;
      await addToCart(variantId, qty, btn);
    });
  }

  function init() {
    document.querySelectorAll('[data-funnel-cart-form]').forEach(wireForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.funnelCart = { addToCart };
})();
